// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oX52bc {
  position: relative;
  width: 100%;
}

.bf7aLO {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  width: 100%;
  min-height: 343px;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
}

.mzGoZI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-2);
  width: 100%;
  padding: 0 0 var(--spacing-1);
}

.ZBqoJv {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
}

.kQWGOb {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: 23px;
  color: var(--text-neutral-dark);
}

.zJzJVE {
  min-height: 20px;
  max-height: 20px;
  padding: 0;
  border-width: 0;
  font-size: var(--font-size-md);
  line-height: 20px;
}

.BFyExl {
  width: 100%;
  height: 1px;
  background-color: var(--stroke-neutral-subtle);
}

.kdsTLm {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  min-height: 240px;
}

._XYEZW {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-3);
  padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3) var(--spacing-3);
  text-align: center;
}

.iFEIzi {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: var(--radius-pill);
  background-color: var(--surface-primary-subtle);
}

.XkAtsH {
  width: 16px;
  height: 16px;
}

.LCSA48 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1);
  color: var(--text-neutral-dark);
}

.OhqAyc {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
}

.uFZHgl {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
}

.A8rhus {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--spacing-2);
  width: 100%;
}

.tvBUB_ {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: 20px;
  color: var(--text-neutral-dark);
}

.afS3Qz .mzGoZI {
  padding: 0;
}

.afS3Qz .kQWGOb {
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
}

.afS3Qz .zJzJVE {
  --size: 14px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}

.afS3Qz .BFyExl {
  background-color: #e6e6e6;
}

.afS3Qz .tvBUB_ {
  font-size: 12px;
  font-weight: 400;
  line-height: 19px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/CardTrackingHomeSection/CardTrackingHomeSection.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".section {\n  position: relative;\n  width: 100%;\n}\n\n.rastreioCard {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  width: 100%;\n  min-height: 343px;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n  width: 100%;\n  padding: 0 0 var(--spacing-1);\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-3);\n}\n\n.title {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: 23px;\n  color: var(--text-neutral-dark);\n}\n\n.seeAllButton {\n  min-height: 20px;\n  max-height: 20px;\n  padding: 0;\n  border-width: 0;\n  font-size: var(--font-size-md);\n  line-height: 20px;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: var(--stroke-neutral-subtle);\n}\n\n.loading {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  justify-content: center;\n  min-height: 240px;\n}\n\n.emptyBody {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: var(--spacing-3);\n  padding: var(--spacing-4-5) var(--spacing-3) var(--spacing-3) var(--spacing-3);\n  text-align: center;\n}\n\n.bigIconWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-pill);\n  background-color: var(--surface-primary-subtle);\n}\n\n.bigIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.emptyText {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1);\n  color: var(--text-neutral-dark);\n}\n\n.emptyTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n}\n\n.emptyDescription {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n}\n\n.listBody {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  width: 100%;\n}\n\n.recentLabel {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: 20px;\n  color: var(--text-neutral-dark);\n}\n\n.migrationPreview .header {\n  padding: 0;\n}\n\n.migrationPreview .title {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 23px;\n}\n\n.migrationPreview .seeAllButton {\n  --size: 14px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.migrationPreview .divider {\n  background-color: #e6e6e6;\n}\n\n.migrationPreview .recentLabel {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 19px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `oX52bc`,
	"rastreioCard": `bf7aLO`,
	"header": `mzGoZI`,
	"headerLeft": `ZBqoJv`,
	"title": `kQWGOb`,
	"seeAllButton": `zJzJVE`,
	"divider": `BFyExl`,
	"loading": `kdsTLm`,
	"emptyBody": `_XYEZW`,
	"bigIconWrapper": `iFEIzi`,
	"bigIcon": `XkAtsH`,
	"emptyText": `LCSA48`,
	"emptyTitle": `OhqAyc`,
	"emptyDescription": `uFZHgl`,
	"listBody": `A8rhus`,
	"recentLabel": `tvBUB_`,
	"migrationPreview": `afS3Qz`
};
module.exports = ___CSS_LOADER_EXPORT___;
